import Box from '@mui/material/Box';
import Container from './Container';
import SectionHeader from './SectionHeader';

/**
 * Envoltorio estándar de una sección de página.
 *
 * tone:
 *   'navy'       → fondo #14213c, texto claro (default)
 *   'navy-dark'  → fondo #0f1a30 (contacto)
 *   'cream'      → fondo #f7f3ec, texto oscuro
 *   'cream-dark' → fondo #efe8db (áreas)
 *
 * Pasa eyebrow/title/lede para renderizar un SectionHeader arriba.
 */
const BG = {
  navy: '#14213c',
  'navy-dark': '#0f1a30',
  cream: '#f7f3ec',
  'cream-dark': '#efe8db',
};

export default function PageSection({
  id,
  tone = 'navy',
  eyebrow,
  title,
  lede,
  align = 'left',
  compact = false,
  children,
  sx = {},
  ...props
}) {
  const dark = tone.startsWith('navy');

  return (
    <Box
      component="section"
      id={id}
      data-nav-theme={dark ? 'dark' : 'light'}
      sx={{
        bgcolor: BG[tone],
        color: dark ? 'text.onDark' : 'text.secondary',
        py: compact
          ? { xs: 8, md: 13 }
          : { xs: 9, md: 'clamp(72px, 10vw, 130px)' },
        ...sx,
      }}
      {...props}
    >
      <Container>
        {(eyebrow || title || lede) && (
          <SectionHeader
            eyebrow={eyebrow}
            title={title}
            lede={lede}
            dark={dark}
            align={align}
          />
        )}
        {children}
      </Container>
    </Box>
  );
}
